import * as React from "react";
import { API, graphqlOperation } from "aws-amplify";
import { listShowBooths } from "graphql/queries";
import BoothLogos from "components/molecures/BrandLogos";
import { navigate } from "gatsby";
type Props = {
  show: any;
};

export default function BoothSelect(props: Props) {
  const { show } = props;
  const [data, setData] = React.useState<any[]>();

  React.useEffect(() => {
    async function f() {
      const res = await API.graphql(
        // @ts-ignore
        graphqlOperation(listShowBooths, {
          filter: { showID: { eq: show.showID } },
        })
      );
      // @ts-ignore
      const sortedItems = res.data.listShowBooths.items.sort((a, b) => {
        if (a.priority && b.priority) {
          return b.priority - a.priority;
        } else if (a.priority && !b.priority) {
          return -1;
        } else if (!a.priority && b.priority) {
          return 1;
        } else {
          return 0;
        }
      });

      setData(sortedItems);
    }
    f();
  }, [show.showID]);
  return (
    <>
      {data && (
        <BoothLogos
          booths={data}
          onClick={(logo) => navigate(`/${show.slug}/booth/${logo.booth.id}`)}
        />
      )}
    </>
  );
}
